module.exports = __webpack_public_path__ + "h5/img/biaoti@2x.d4807f9b.png";